/**
 * CommissionDashboard — shared commission summary component.
 *
 * Used by both ResellerDashboard and FreelanceDashboard.
 * Shows three metric cards: Pendiente, Aprobado, Pagado.
 */

import { formatCents } from './formatters'

interface CommissionDashboardProps {
  pendingCommissionsCents: number
  approvedCommissionsCents: number
  paidCommissionsCents: number
}

export function CommissionDashboard({
  pendingCommissionsCents,
  approvedCommissionsCents,
  paidCommissionsCents,
}: CommissionDashboardProps) {
  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold text-gray-900">Resumen de Comisiones</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {/* Pending */}
        <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-5 shadow-sm">
          <p className="text-sm font-medium text-yellow-700">Pendiente</p>
          <p className="mt-2 text-2xl font-bold text-yellow-900">
            {formatCents(pendingCommissionsCents)}
          </p>
          <p className="mt-1 text-xs text-yellow-600">En espera de aprobacion</p>
        </div>

        {/* Approved */}
        <div className="rounded-lg border border-blue-200 bg-blue-50 p-5 shadow-sm">
          <p className="text-sm font-medium text-blue-700">Aprobado</p>
          <p className="mt-2 text-2xl font-bold text-blue-900">
            {formatCents(approvedCommissionsCents)}
          </p>
          <p className="mt-1 text-xs text-blue-600">Aprobado, pendiente de pago</p>
        </div>

        {/* Paid */}
        <div className="rounded-lg border border-green-200 bg-green-50 p-5 shadow-sm">
          <p className="text-sm font-medium text-green-700">Pagado</p>
          <p className="mt-2 text-2xl font-bold text-green-900">
            {formatCents(paidCommissionsCents)}
          </p>
          <p className="mt-1 text-xs text-green-600">Pagado en total</p>
        </div>
      </div>
    </div>
  )
}
